/**
 * Created by Shiv Roy on 21/12/17.
 */
import React from 'react';
// import noImage from '../../../../../img/noimage.png';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { showFormatedDate } from '../../../../../actions/utilAction';
import { getPatientAllergiesList,
  getPatientAppointmentList,
  getPatientAuthorizationList,
  getPatientDetails,
  getPatientFamilyHistoryList,
  getPatientImmunizationList,
  getPatientInsuranceList,
  getPatientLabsList,
  getPatientMedicationList,
} from '../actions';
import moment from 'moment';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { Tab, Tabs } from 'material-ui/Tabs';
import userImage from '../../../../../img/doctor.png';

// const styles = {
//   headline: {
//     fontSize: 24,
//     paddingTop: 16,
//     marginBottom: 12,
//     fontWeight: 400,
//   },
// };

class PatientDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // patientId: 242,
      // value: 1,
      activeTab: 0,
      activeTabValue: '0',
      slideIndex: null,
    };
  }

  componentWillMount() {
    this.props.getPatientDetails(this.props.patientId);
    // let searchObj = {
    //   filters: { patientid: this.props.patientId },
    //   sort_fields: '-id',
    //   page_number: 1,
    //   includes: 'include=insurancecompanies',
    // };
    this.props.getPatientInsuranceList(this.props.patientId);
  }

  setActive(tabValue) {
    if (tabValue === this.state.activeTab) {
      return false;
    }

    // console.log('active tab ...', tabValue);
    this.setState({ activeTab: tabValue });
    // let searchObj = {
    //   filters: { patientid: this.props.patientId },
    //   sort_fields: '-id',
    //   page_number: 1,
    // };
    switch (tabValue) {
    case 0:
      // searchObj.includes = 'include=insurancecompanies';
      this.props.getPatientInsuranceList(this.props.patientId);
      break;
    case 1:
      // searchObj.includes = 'include=insurancecompanies';
      let newSearchObj = {
        patientId: this.props.patientId,
        authType: null,
        page_number: 1,
        pageSize: 100,
      };
      this.props.getPatientAuthorizationList(newSearchObj);
      break;
    case 2:
      let searchObjectAppoinment = {
        filters: {
          'patientIds': this.props.patientId,
          'locationIds': this.props.currentLocationId,
        },
      };
      this.props.getPatientAppointmentList(searchObjectAppoinment);
      break;
    }
  }

  handleTabChange = (value) => { //  Change Tab on form Submit.
    this.setState({ activeTabValue: value, activeTab: value });
  };

  renderNoRecordFound() {
    return (
      <div className="col-sm-12 history_card mt20">
        <div className="familydl text-center no-record">
          No record found.
        </div>
      </div>
    );
  }

  // renderVitals = () => {
  //   return this.props.patientVitals.map((vital, i) => {
  //     return (
  //       <div className="col-sm-6 history_card mt20" key={i}>
  //         <Card>
  //           <div className="carditem">
  //             <ul>
  //               <li><label>Heart Beat : </label> <span>{vital.heartRate || 'N/A'}</span></li>
  //               <li><label>BMI : </label> <span>{vital.bmi || 'N/A'}</span></li>


  //               <li><label>Blood pressure : </label> <span>{vital.bpDiastolic || 'N/A'}</span></li>
  //               <li><label>Pulse : </label> <span>{vital.pulse || 'N/A'}</span></li>
  //               <li><label>Resp : </label> <span>{vital.respiration || 'N/A'}</span></li>


  //               <li><label>Temperature (°C) : </label> <span>{vital.temperature || 'N/A'}</span></li>
  //               <li><label>Height : </label> <span>{vital.heightIn || 'N/A'}</span></li>
  //               <li><label>Weight (Lb) : </label> <span>{vital.weightLbs || 'N/A'}</span></li>
  //             </ul>
  //           </div>
  //         </Card>
  //       </div>
  //     );
  //   });
  // };

  renderDiagnosis = () => {
    return this.props.patientDiagnosis.map((diagnosis, i) => {
      return (
        <div className="col-sm-6 history_card mt20" key={i}>
          <Card>
            <div className="carditems">
              <ul>
                <li><label>Code : </label> <span>{diagnosis.code}</span></li>
                <li><label>Description : </label> <span>{diagnosis.description}</span></li>
              </ul>
            </div>
          </Card>
        </div>
      );
    });
  };


  renderAppointmentData() {
    // console.log('appointment data...', this.props.patientAppointmentList);
    if (!this.props.patientAppointmentList || !this.props.patientAppointmentList.data.length) {
      return (
        this.renderNoRecordFound()
      );
    }
    return this.props.patientAppointmentList.data.map((appointment, index) => {
      let staffNames = [];
      staffNames = appointment.appointmentStaffs.map((staff) => {
        return staff.staffName;
      });
      let startDateTime = appointment.startDateTime;
      let endDateTime = appointment.endDateTime;
      let startTime = moment(startDateTime).format('h:mm A');
      let endTime = moment(endDateTime).format('h:mm A');
      let note = appointment.notes ? appointment.notes : '-';
      let staffName = staffNames && staffNames.length ? staffNames.join(',') : 'No Staff';
      let appointmentTypeName = appointment.appointmentTypeName ? appointment.appointmentTypeName : '-';
      return (
        <div className="col-sm-6 history_card mt20" key={appointment.patientAppointmentId}>
          <Card>
            <CardHeader className="cardheader"
              title={staffName}
              actAsExpander={false}
              showExpandableButton={false}
            />
            <div className="familydl">
              <ul>
                <li>Appointment : <span>{appointmentTypeName}</span></li>
                <li>Date : <span>{showFormatedDate(startDateTime)}</span></li>
                <li>Time : <span>{`${startTime} - ${endTime}`}</span></li>
              </ul>
            </div>
            <CardText className="disascontent" expandable={false}>
              <p>Note</p>
              {note}
            </CardText>
          </Card>
        </div>
      );
    });
  }

  renderInsuranceData() {
    // console.log('insurance data...', this.props.patientInsuranceList);
    if (!this.props.patientInsuranceList.length) {
      return (
        <tr><td colSpan="6" className="text-center no-record">No record found.</td></tr>
      );
    }
    return this.props.patientInsuranceList.map((Obj, index) => {
      let data = Obj;
      return (
        <tr key={data.id}>
          <td>{data.insuranceCompanyName || '-'}</td>
          <td>{data.cardIssueDate ? showFormatedDate(data.cardIssueDate) : '-'}</td>
          <td>{data.insuranceIDNumber || '-'}</td>
          <td>{data.insurancePlanName || '-'}</td>
          <td>{data.payerPreference || '-'}</td>
          <td>{data.insuranceCompanyAddress || '-' }</td>
        </tr>
      );
    });
  }

  renderAuthorizationData() {
    // console.log('authorization data...', this.props.patientAuthorizationList);
    if (!this.props.patientAuthorizationList.length) {
      return (
        <tr><td colSpan="5" className="text-center no-record">No record found.</td></tr>
      );
    }
        
    return this.props.patientAuthorizationList && this.props.patientAuthorizationList.length > 0 && this.props.patientAuthorizationList.filter(x=>x.isRemoveFromDashboard === false).map((data, index) => {
      return (
        <tr key={data.authorizationId}>
          <td>{data.authorizationNumber || '-'}</td>
          <td>{data.authorizationTitle || '-'}</td>
          <td>{data.payerName || '-'}</td>
          <td>{data.startDate ? showFormatedDate(data.startDate) : '-'}</td>
          <td>{data.endDate ? showFormatedDate(data.endDate) : '-'}</td>
        </tr>
      );
    });
  }

  handleChange = (event, index, value) => this.setState({ value });
  render() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,

    });
    var styles = {
      default_tab: {
        height: '50px',
        fontSize: '13px',
      },
      active_tab: {
        color: '#fff',
        backgroundColor: '#089ccd',
        height: '48px',
        fontSize: '13px',
      },
    };
    styles.tab = [];
    styles.tab[0] = styles.default_tab;
    styles.tab[1] = styles.default_tab;
    styles.tab[2] = styles.default_tab;
    styles.tab[3] = styles.default_tab;
    styles.tab[4] = styles.default_tab;
    styles.tab[5] = styles.default_tab;
    styles.tab[this.state.activeTab] = styles.active_tab;
    // styles.tab[this.state.activeTab2] = styles.active_tab;
    styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);

    var ssnLast4DigitsArray = [];
    var ssnLast4Digits = '';

    if (this.props.patientInfo.ssn) {
      for (let i = 7; i <= 10;i++) {
        ssnLast4DigitsArray.push(this.props.patientInfo.ssn[i]);
      };
      ssnLast4Digits = ssnLast4DigitsArray[0] + '' + ssnLast4DigitsArray[1] + '' + ssnLast4DigitsArray[2] + '' + ssnLast4DigitsArray[3];
    }

    return (
      <div>
        <h2 className="page_title">My Profile</h2>
        <div className="clearfix"></div>
        <div className="row">
          <div className="col-sm-12">
            <div className="readmin-panel crop">
              {this.props.patientInfo !== null ?
                <div className="panel-body pd15">
                  <div className="lineheader">
                    <p>Basic Information</p>
                    {/* <a href="#"><i className="fa fa-plus" aria-hidden="true"></i></a>*/}
                  </div>
                  {/* {this.props.patientInfo.photoThumbnailPath ?
                    <div className="clientpic"><img src={this.props.patientInfo.photoThumbnailPath} alt="" /></div>
                    :
                    <div className="clientpic"><img src={noImage} alt="No Image" /></div>
                  } */}
                  <div className="clientpic">
                    {this.props.patientInfo.photoThumbnailPath ? <img src={this.props.patientInfo.photoThumbnailPath} alt="" /> : this.props.patientInfo.name ? (this.props.patientInfo.name.split(' ').length > 1 ? <span className="userletter">{this.props.patientInfo.name.split(' ')[0][0].toUpperCase() + this.props.patientInfo.name.split(' ')[this.props.patientInfo.name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{this.props.patientInfo.name[0].toUpperCase()}</span>) : ''}
                  </div>
                  <div className="clientdetail">
                    <p><label>Name : </label> <span>{this.props.patientInfo.name}</span></p>
                    {/* <p><label>D.O.B : </label> <span>02/12/1987 (30yrs)</span></p>*/}
                    <p><label>D.O.B : </label> <span>{moment(this.props.patientInfo.dob).format('MM/DD/YYYY')}</span></p>
                    <p><label>Gender : </label> <span>{this.props.patientInfo.gender}</span></p>
                    <p><label>SSN : </label> <span>{this.props.patientInfo.ssn ? '***-**-' + ssnLast4Digits : '***-**-****'}<i aria-hidden="true"></i></span></p>
                    <p><label>Client ID : </label> <span>{this.props.patientInfo.mrn}</span></p>
                    <p><label>Status : </label> <span className="greenfont">{this.props.patientInfo.status}</span></p>
                    <p><label>Phone : </label> <span>{this.props.patientInfo.phone}</span></p>
                    <p><label>Email : </label> <span>{this.props.patientInfo.email}</span></p>
                    <address>
                      <label>Address : </label> <span>{this.props.patientInfo.address}</span>
                    </address>
                  </div>
                </div>
                :
                null
              }

            </div>
          </div>
          {<div className="col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Appointment Details</p>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-xl-6 lastdr">
                        <h3>Upcoming Appointment</h3>
                        <div className="latestdoctor">
                          <img src={(this.props.upcomingAppointment && this.props.upcomingAppointment.staffImageUrl) || userImage} alt="" />
                        </div>
                        {this.props.upcomingAppointment && this.props.upcomingAppointment.upcomingAppointmentStaff ?
                          <div className="latestcontent">
                            <ul>
                              <li>{this.props.upcomingAppointment.upcomingAppointmentStaff}</li>
                              <li>{moment(this.props.upcomingAppointment.upcomingAppointment).format('MM/DD/YYYY')}</li>
                            </ul>
                          </div>
                          :
                          <div className="latestcontent">
                            <div className="familydl text-center">
                              No record found.
                            </div>
                          </div>
                        }

                      </div>
                      <div className="col-lg-12 col-xl-6 lastdr">
                        <h3>Last Appointment</h3>
                        <div className="latestdoctor">
                          <img src={(this.props.lastAppointment && this.props.lastAppointment.staffImageUrl) || userImage} alt="" />
                        </div>
                        {this.props.lastAppointment && this.props.lastAppointment.lastAppointmentStaff ?
                          <div className="latestcontent">
                            <ul>
                              <li>{this.props.lastAppointment.lastAppointmentStaff}</li>
                              <li>{ moment(this.props.lastAppointment.lastAppointment).format('MM/DD/YYYY')}</li>
                              {/* <li>02/05/2017, <span>2.15pm</span></li>*/}
                            </ul>
                          </div>
                          :
                          <div className="latestcontent">
                            <div className="familydl text-center">
                              No record found.
                            </div>
                          </div>
                        }

                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {/* <div className="col-sm-12">
            <div className="readmin-panel crop vitalbox">
              <div className="panel-body pd15">
                <div className="lineheader">
                  <p>  Vitals </p>
                </div>
                <div className="row">
                  {this.props.patientVitals && this.props.patientVitals.length > 0 ? this.renderVitals() : this.renderNoRecordFound()}
                </div>
              </div>
            </div>
          </div> 
          <div className="col-sm-12">
            <div className="readmin-panel crop vitalbox">
              <div className="panel-body pd15">
                <div className="lineheader">
                  <p>  Diagnosis </p>
                </div>
                <div className="row">
                  {this.props.patientDiagnosis && this.props.patientDiagnosis.length > 0 ? this.renderDiagnosis() : this.renderNoRecordFound()}
                </div>
              </div>
            </div>
          </div>*/}


          {/* Client tabs panel 1 Details starts here ...... */}
          <div className="col-sm-12">
            <div className="readmin-panel crop appoint">
              <div className="panel-body pd15">
                <div className="lineheader border0">
                  <p>Current Overview</p>
                </div>
                <Tabs className="tabbox" value={this.state.activeTabValue} onChange={this.handleTabChange}>

                  <Tab className="customtab"
                    onClick={(e) => this.setActive(0)}
                    style={styles.tab[0]}
                    value="0"
                    icon={<span className="fa fa-medkit" aria-hidden="true"></span>}
                    label={<font>Insurance</font>}>
                    <div>
                      <div className="table-responsive mt-15">
                        <table className={tableClass}>
                          <thead>
                            <tr>
                              <th width="20%">Insurance Company</th>
                              <th width="15%">Issue Date</th>
                              <th width="15%">ID Number</th>
                              <th width="15%">Plan Name</th>
                              <th width="15%">Payer Preference</th>
                              <th width="25%">Company Address</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.activeTab === 0 ? this.renderInsuranceData() : null}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Tab>
                  <Tab className="customtab"
                    onClick={(e) => this.setActive(1)}
                    style={styles.tab[1]}
                    value="1"
                    icon={<span className="fa fa-file-text font24" aria-hidden="true"></span>}
                    label={<font>AUTHORIZATIONS</font>}>
                    <div>
                      <div className="table-responsive mt-15">
                        <table className={tableClass}>
                          <thead>
                            <tr>
                              <th width="20%">Auth #</th>
                              <th width="15%">Title</th>
                              <th width="35%">Insurance Company</th>
                              <th width="15%">Start Date</th>
                              <th width="15%">End Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.activeTab === 1 ? this.renderAuthorizationData() : null}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Tab>

                  {/* <Tab className="customtab"
                    onClick={(e) => this.setActive(2)}
                    style={styles.tab[2]}
                    value="2"
                    icon={<span className="fa fa-calendar" aria-hidden="true"></span>}
                    label={<font>Appointment</font>}>
                    <div>
                      <div className="row">
                        {this.state.activeTab === 2 ? this.renderAppointmentData() : null}
                      </div>
                    </div>
                  </Tab> */}
                </Tabs>
              </div>
            </div>
          </div>

          {/* Client tabs panel 2 Details starts here ...... */}
          {/* <div className="col-sm-12">
            <div className="readmin-panel crop appoint">
              <div className="panel-body pd15">
                <div className="lineheader border0">
                  <p>Client History</p>
                </div>
                <Tabs className="tabbox" value={this.state.activeTabValue2} onChange={this.handleTabChange2}>
                  <Tab className="customtab"
                    onClick={(e) => this.setActive2(0)}
                    style={styles.tab[0]}
                    value="0"
                    icon={<FontIcon className="material-icons">grain</FontIcon>}
                    label={<font>Allergies</font>} >
                    <div>
                      <div className="table-responsive mt-15">
                        <table className={tableClass}>
                          <thead>
                            <tr>
                              <th width="20%">Allergy Type</th>
                              <th width="20%">Allergen</th>
                              <th width="15%">Source</th>
                              <th width="15%">Reaction</th>
                              <th width="15%">Created Date</th>
                              <th width="15%">Status</th>

                            </tr>
                          </thead>
                          <tbody>
                            {this.state.activeTab2 === 0 ? this.renderAllergiesData() : null}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Tab>


                  <Tab className="customtab"
                    onClick={(e) => this.setActive2(3)}
                    style={styles.tab[3]}
                    value="3"
                    icon={<span className="fa fa-history" aria-hidden="true"></span>}
                    label={<font>HISTORY</font>}>
                    <div>
                      <div className="row">
                        {this.state.activeTab2 === 3 ? this.renderFamilyHistoryData() : null}
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div> */}


        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let patientId;
  if (state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.roleName === 'Client') {
    patientId = state.login.loginUserInfo.id;
  } else {
    patientId = state.patient.patientId;
  }
  // console.log('state.patientPortal.patientPortalDetails.................', state.patientPortal.patientPortalDetails);

  // customization for patient insurances ...
  let patientInsuranceList = [];
  if (state.patientPortal.patientInsuranceList && state.patientPortal.patientInsuranceList.data) {
    patientInsuranceList = state.patientPortal.patientInsuranceList.data.PatientInsurance || [];
  }
  // customization for patient authorizations ...
  let patientAuthorizationList = [];
  if (state.patientPortal.patientAuthorizationList && state.patientPortal.patientAuthorizationList.data) {
    patientAuthorizationList = state.patientPortal.patientAuthorizationList.data.Authorization || [];
  }
  return {
    currentLocationId: state.login.currentLocationId,
    patientId: patientId,
    patientPortalDetails: state.patientPortal.patientPortalDetails,
    patientInfo: state.patientPortal.patientPortalDetails && state.patientPortal.patientPortalDetails.patientInfo.length ? state.patientPortal.patientPortalDetails.patientInfo[0] : {},
    patientVitals: state.patientPortal.patientPortalDetails ? state.patientPortal.patientPortalDetails.patientVitals : [],
    upcomingAppointment: state.patientPortal.patientPortalDetails && state.patientPortal.patientPortalDetails.upcomingAppointmentDetails.length ? state.patientPortal.patientPortalDetails.upcomingAppointmentDetails[0] : {},
    lastAppointment: state.patientPortal.patientPortalDetails && state.patientPortal.patientPortalDetails.lastAppointmentDetails.length ? state.patientPortal.patientPortalDetails.lastAppointmentDetails[0] : {},
    patientDiagnosis: state.patientPortal.patientPortalDetails ? state.patientPortal.patientPortalDetails.patientDiagnosisDetails : [],
    patientImmunizationList: state.patientPortal.patientImmunizationList,
    patientMedicationList: state.patientPortal.patientMedicationList,
    patientLabsList: state.patientPortal.patientLabsList,
    patientAppointmentList: state.patientPortal.patientAppointmentList,
    patientAllergiesList: state.patientPortal.patientAllergiesList,
    patientInsuranceList: patientInsuranceList,
    patientAuthorizationList: patientAuthorizationList,
    patientFamilyHistoryList: state.patientPortal.patientFamilyHistoryList,
  };
}

export default connect(mapStateToProps, { getPatientDetails, getPatientImmunizationList, getPatientMedicationList, getPatientLabsList, getPatientAppointmentList, getPatientAllergiesList, getPatientAuthorizationList, getPatientInsuranceList, getPatientFamilyHistoryList })(PatientDetails);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/components/my_profile_Client.js